module.exports = __webpack_public_path__ + "img/goldmedal.c5b4adcf.png";